import { iOnchainExecutionIdAbi } from "@gearbox-protocol/sdk/dev";
import { useQuery } from "@tanstack/react-query";
import { publicActions } from "viem";
import { useWalletClient } from "wagmi";

import { useUnpausedForkStatus } from "./context";

export default function useExecutionIdRPCMismatch(): boolean {
  const { onchainExecutionId, executionId } = useUnpausedForkStatus();
  const { data: walletClient } = useWalletClient();

  const { data: mismatch = false } = useQuery({
    enabled: !!walletClient && !!onchainExecutionId,
    queryKey: [
      "executionIdRPCMismatch",
      walletClient?.uid,
      walletClient?.account?.address,
      walletClient?.chain?.id,
      onchainExecutionId,
      executionId,
    ],
    queryFn: async () => {
      if (!walletClient || !onchainExecutionId) {
        return false;
      }
      try {
        const exId = await walletClient.extend(publicActions).readContract({
          abi: iOnchainExecutionIdAbi,
          address: onchainExecutionId,
          functionName: "executionId",
        });
        return exId !== executionId;
      } catch {
        return true;
      }
    },
    refetchInterval: 5_000,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  return mismatch;
}
